module.exports = __webpack_public_path__ + "img/sub27.46931966.jpg";